export default {"src":"/_next/static/media/khanoumi.8bf8764c.svg","height":48,"width":121,"blurWidth":0,"blurHeight":0};